/**
 * Created by Administrator on 2017/5/24.
 *   分页组件
 *   @param data={ "last": true,"totalElements": 11,"totalPages": 1,"number": 0,"size": 15,"first": true,"numberOfElements": 11 }
 *   @param page={pageNumber:1,pageSize:10}
 *   @event change function
 *   使用方法
 *   <pagination (change)="refresh()" [(page)]="page" [(data)]="data"></pagination>
 */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
@Component({
  selector: 'pagination',
  template: `
    <div class="page-all">
      <ul class="pagination-list">
        <li class="page-first">
          <button (click)="refresh(1)" [disabled]="page.pageNumber<=1">
            <i class="fa fa-angle-double-left"></i>
          </button>
        </li>
        <li class="page-two">
          <button (click)="refresh((page.pageNumber-1))" [disabled]="page.pageNumber<=1">
            <i class="fa fa-angle-left"></i>
          </button>
        </li>
      </ul>
      <div class="page-info">
        <span>Page</span>
        <input type="number" [(ngModel)]="page.pageNumber" (change)="refresh(page.pageNumber)">
        <span>of {{data.totalPages}}</span>
      </div>
      <ul class="pagination-list">
        <li class="page-above">
          <button (click)="refresh((page.pageNumber+1))" [disabled]="data.number>=data.totalPages-1">
            <i class="fa fa-angle-right"></i>
          </button>
        </li>
        <li class="page-last">
          <button (click)="refresh(data.totalPages)" [disabled]="data.number>=data.totalPages-1">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </li>
      </ul>
    </div>
  `,
  styleUrls: ['./pagination.component.css']
})
export class Pagination implements OnInit {
  constructor(
  ) { }
  //获取父类的变量值
  @Input() page: any = '';
  @Input() data: any = '';

  //反馈到父类
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() change = new EventEmitter();
  private currentPage: number;

  //初始化

  ngOnInit() {
  }

  private refresh(page: any): void {
    if (page > this.data.totalPages || page < 1) {
      this.page.pageNumber = this.data.number + 1;
      return;
    } else {
      this.page.pageNumber = page
      this.currentPage = page;
      this.pageChange.emit(this.page);
      this.dataChange.emit(this.data);
      this.change.emit();
    }


  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/pagination/pagination.component.ts